import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/firebase.config.js'
import * as Firebase from 'firebase/app'
import 'firebase/firestore'
import 'babel-polyfill'

import authentication from '@/store/modules/authentication.js'
import app from '@/store/modules/app.js'
import items from '@/store/modules/items.js'
import vendors from '@/store/modules/vendors.js'
import promos from '@/store/modules/promos.js'
import cpp from '@/store/modules/cpp.js'
import leasing from '@/store/modules/leasing.js'
import quotes from '@/store/modules/quotes.js'
import opportunities from '@/store/modules/opportunities.js'

Firebase.initializeApp(config)

Vue.use(Vuex)

const state = {
  db: Firebase.firestore(),
  sync: {
    payloadSize: 500,
    period: 1000,
  }
}

const modules = {
  auth: authentication,
  app: app,
  items: items,
  vendors: vendors,
  promos: promos,
  cpp: cpp,
  leasing: leasing,
  quotes: quotes,
  opportunities: opportunities,
}

const actions = {
  init({commit}, mods) {
    mods.forEach(mod => {
      store.dispatch(`${mod}/init`)
    })
  },
  close() {
    /* Object.keys(modules).forEach(mod => {
      if(['auth', 'app'].indexOf(mod) === -1) store.dispatch(`${mod}/close`)
    }) */
  },
}

const store = new Vuex.Store({
  state,
  modules,
  actions,
})

export default store
